import React, { useEffect, useState } from "react";
import { Checkbox, Col, Modal, Row } from "antd";
import { useTranslation } from "react-i18next";
import "../../../../assets/style/modalStyle/postNews.scss";
import { useDispatch, useSelector } from "react-redux";

import ModalAddCategory from "./ModalAddCategory";
import { storeProductSelector } from "../../../../services/selector/index.";
import { checkNumber, validateUrl } from "../../../../utils/functionCommon";
import {
  createProduct,
  setOpenModalAddProduct,
} from "../../../../services/slice/StoreSlice";
import BaseButton from "../../Button/BaseButton";
import { IconUpLoad } from "../../../../assets/icon";
import LabelInput from "../../LabelInput";
import InputText from "../../Input/InputText";
import UpImageEdit from "../../Button/UpImageEdit";

const ModalAddProduct = ({ title, postDeals }) => {
  const stateStore = useSelector(storeProductSelector);
  const { isOpenModalAddProduct, isOpenModalAddCategry } = stateStore;
  const [datapost, setDataPost] = useState({
    name: "",
    descriptions: "",
    content: "",
    price: "",
    priceDrop: null,
    categoryId: 1,
    code: "",
    orderLink: "",
    detailLink: "",
    typeButton: 1,
  });
  const [image, setImage] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [error, setError] = useState({
    isError: false,
    msg: "",
  });
  useEffect(() => {
    if (stateStore.isError) {
      setError({
        isError: true,
        msg: stateStore.msg,
      });
    }
  }, [stateStore.isError, stateStore.msg]);

  const handleSave = () => {
    if (
      !datapost.name ||
      (!datapost.price && !datapost.priceText) ||
      (parseInt(datapost.typeButton) === 1 && !datapost.orderLink) ||
      !image
    ) {
      setError({
        isError: true,
        msg: "Vui lòng nhập đầy đủ thông tin",
      });
      return;
    }
    if (
      parseInt(datapost.typeButton) === 1 &&
      !validateUrl(datapost.orderLink)
    ) {
      setError({
        isError: true,
        msg: "Đường dẫn không hợp lệ",
      });
      return;
    }

    if (image.size > 2 * 1024 * 1024) {
      setError({
        isError: true,
        msg: "Dung lượng ảnh phải nhỏ hơn < 2MB",
      });
      return;
    }

    if (Number(datapost.price) < Number(datapost.priceDrop)) {
      setError({
        isError: true,
        msg: "Giá ưu đãi phải nhỏ hơn Giá gốc",
      });
      return;
    }

    const formPost = new FormData();
    formPost.append("file", datapost.fileImage);
    formPost.append("descriptions", datapost.descriptions);
    if (datapost.content !== "") {
      formPost.append(
        "content",
        datapost.content.replace(
          new RegExp(window.SERVER_URL ? window.SERVER_URL : "", "g"),
          ""
        )
      );
    }
    formPost.append("code", datapost.code);
    formPost.append("name", datapost.name);
    formPost.append("price", datapost.price);
    if (datapost.workCCS) {
      formPost.append("workCCS", datapost.workCCS);
    }
    if (datapost.productTypeId) {
      formPost.append("productTypeId ", datapost.productTypeId);
    }
    if (datapost.priceDrop) {
      formPost.append("priceDrop", datapost.priceDrop);
    }
    formPost.append("categoryId", datapost.categoryId);
    formPost.append("orderLink", datapost.orderLink);
    formPost.append("detailLink", datapost.detailLink);
    formPost.append("typeButton", datapost.typeButton);
    dispatch(createProduct(formPost));
  };

  const handleCancel = () => {
    dispatch(setOpenModalAddProduct(false));
  };
  const [valueCheck, setValueCheck] = useState("1");
  const onCheck = (value) => {
    if (parseInt(value) === 1) {
      setDataPost({ ...datapost, typeButton: parseInt(value) });
      setValueCheck(value);
    } else {
      setDataPost({ ...datapost, orderLink: "", typeButton: parseInt(value) });
      setValueCheck(value);
    }
  };
  return (
    <>
      {isOpenModalAddCategry ? <ModalAddCategory /> : null}
      <Modal
        maskClosable={false}
        className="wrapperModalPostNews"
        title={t(title)}
        centered
        width={1300}
        open={isOpenModalAddProduct}
        onCancel={handleCancel}
        footer={[
          <BaseButton
            content={"Đăng sản phẩm"}
            typeBtn="btnOrange"
            icon={<IconUpLoad />}
            handleClick={handleSave}
          />,
        ]}
      >
        <Row>
          <Col span={4}>
            <LabelInput text={"Tên sản phẩm"} />
          </Col>
          <Col span={20}>
            <InputText
              focus
              text={datapost.name}
              setText={(value) => setDataPost({ ...datapost, name: value })}
              placeholder={"Nhập tên sản phẩm"}
              maxLength={155}
              typeInput={`${
                !datapost.name && error.isError
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }`}
            />
          </Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={4}>
            <LabelInput text={"Mô tả"} />
          </Col>
          <Col span={20}>
            <InputText
              typeInput={"baseInput"}
              text={datapost.descriptions}
              setText={(value) =>
                setDataPost({ ...datapost, descriptions: value })
              }
              placeholder={"Nhập mô tả về sản phẩm"}
            />
          </Col>
        </Row>

        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={4}>{/* <LabelInput text={"Link đặt mua"} /> */}</Col>
          <Col span={20}>
            <Checkbox.Group
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
              }}
              value={valueCheck}
            >
              <Col span={3}>
                <Checkbox value={"1"} onClick={() => onCheck("1")}>
                  Nút đặt mua
                </Checkbox>
              </Col>
              <Col span={10}>
                <InputText
                  width={293}
                  text={datapost.orderLink}
                  setText={(value) =>
                    setDataPost({ ...datapost, orderLink: value })
                  }
                  style={{ width: "291px" }}
                  placeholder={"Nhập link đặt mua sản phẩm"}
                  typeInput={`${
                    !datapost.orderLink &&
                    error.isError &&
                    parseInt(datapost.typeButton) === 1
                      ? "checkEmptyText baseInput"
                      : "baseInput"
                  }`}
                />
              </Col>
              <Col span={4}>
                <Checkbox value={"2"} onClick={() => onCheck("2")}>
                  Nút liên hệ
                </Checkbox>
              </Col>
            </Checkbox.Group>
          </Col>
        </Row>
        <Row style={{ margin: "1.5rem 0" }}>
          <Col span={4}>
            <LabelInput text={"Link chi tiết"} />
          </Col>
          <Col span={20}>
            <InputText
              text={datapost.detailLink}
              setText={(value) =>
                setDataPost({ ...datapost, detailLink: value })
              }
              placeholder={"Nhập link chi tiết sản phẩm"}
              typeInput={`${
                !datapost.detailLink && error.isError
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }`}
            />
          </Col>
        </Row>
        <Row justify={"end"} style={{ position: "relative" }}>
          <Col span={20}>
            <Row justify={"space-between"} style={{ width: "100%" }}>
              <Col span={12}>
                <Row style={{ width: "100%" }}>
                  <Col span={7}>
                    <span className="label">{t("Đặt ảnh sản phẩm")}:</span>
                  </Col>
                  <Col span={15}>
                    {/* <UploadImage
                      style={
                        !image && error.isError
                          ? { border: "1px solid red" }
                          : null
                      }
                      setImage={(e) => setImage(e)}
                    /> */}
                    <UpImageEdit
                      setImage={setImage}
                      width={"20.7rem"}
                      height={"237px"}
                      accept={".png, .jpg, .jpeg, .gif"}
                      image={image}
                      setFile={(value) =>
                        setDataPost({ ...datapost, fileImage: value })
                      }
                      widthImage={207}
                      heightImage={237}
                      style={
                        (!image && error.isError) ||
                        error.msg === "File có định dạng .jpeg, .png, .gif" ||
                        error.msg === "Dung lượng ảnh phải nhỏ hơn < 2MB" ||
                        error.msg === "Kích thước ảnh không hợp lệ"
                          ? { border: "1px solid red" }
                          : null
                      }
                    />
                  </Col>
                  {postDeals && (
                    <>
                      <Col span={4}>
                        <span className="label">
                          {t("Đối tượng hiển thị")}:
                        </span>
                      </Col>
                      <Col span={6}></Col>
                    </>
                  )}
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={8}>
                    <LabelInput text={"Giá gốc"} />
                  </Col>
                  <Col span={16} style={{ position: "relative" }}>
                    <InputText
                      maxLength={155}
                      placeholder={"Nhập giá gốc sản phẩm"}
                      setText={(value) =>
                        setDataPost({
                          ...datapost,
                          price: value,
                        })
                      }
                      text={datapost.price}
                      typeInput={`${
                        !datapost.price && error.isError
                          ? // (error.isError && !checkNumber(datapost.price))
                            "checkEmptyText baseInput"
                          : "baseInput"
                      }`}
                    />
                  </Col>
                </Row>
                <Row style={{ margin: "1.5rem 0" }}>
                  <Col span={8}>
                    <LabelInput text={"Giá ưu đãi"} />
                  </Col>
                  <Col span={16}>
                    <InputText
                      maxLength={155}
                      placeholder={"Nhập giá ưu đãi"}
                      setText={(value) =>
                        setDataPost({ ...datapost, priceDrop: value })
                      }
                      text={datapost.priceDrop}
                      typeInput={`${
                        (error.isError &&
                          error.msg === "Giá ưu đãi phải nhỏ hơn Giá gốc") ||
                        (error.datapost && !checkNumber(datapost.priceDrop))
                          ? "checkEmptyText baseInput"
                          : "baseInput"
                      }`}
                    />
                  </Col>
                </Row>

                <Row style={{ margin: "1.5rem 0" }}>
                  <Col span={8}>
                    <LabelInput text={"Mã sản phẩm"} />
                  </Col>
                  <Col span={16}>
                    <InputText
                      maxLength={13}
                      placeholder={"Nhập mã sản phẩm"}
                      setText={(value) =>
                        setDataPost({ ...datapost, code: value })
                      }
                      text={datapost.code}
                      typeInput={` "baseInput"
                      }`}
                    />
                  </Col>
                </Row>
                <Row style={{ margin: "1.5rem 0" }}>
                  <Col span={8}>
                    <LabelInput text={"Nhóm sản phẩm"} />
                  </Col>
                  <Col span={16}>
                    <InputText
                      maxLength={13}
                      placeholder={"Nhập mã nhóm sản phẩm"}
                      setText={(value) =>
                        setDataPost({ ...datapost, productTypeId: value })
                      }
                      text={datapost.productTypeId}
                      typeInput={` "baseInput"
                      }`}
                    />
                  </Col>
                </Row>
                <Row style={{ margin: "1.5rem 0" }}>
                  <Col span={8}>
                    <LabelInput text={"Mã chia việc CCS"} />
                  </Col>
                  <Col span={16}>
                    <InputText
                      maxLength={13}
                      placeholder={"Nhập mã chia việc CCS"}
                      setText={(value) =>
                        setDataPost({ ...datapost, workCCS: value })
                      }
                      text={datapost.workCCS}
                      typeInput={` "baseInput"
                      }`}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          {error.isError ? (
            <small className="msgError" style={{ bottom: -50, left: 220 }}>
              {t(error.msg)}
            </small>
          ) : null}
        </Row>
      </Modal>
    </>
  );
};

export default ModalAddProduct;
